import {addDays} from 'date-fns';
import {CAMPAIGN_TYPE} from 'Pages/apps/default/projectPages/campaign/const';

export class CampaignWizardDataObject {
	/**
	 * @param {CampaignType} [type=CAMPAIGN_TYPE.REGULAR] - Campaign type.
	 * @param {string} [projectId=''] - DB ID of the campaign project.
	 * @param {string} [name=''] - Campaign name.
	 * @param {string} [description=''] - Campaign description.
	 * @param {?Date} [startDate=new Date()] - Campaign and message definition start date.
	 * @param {?Date} [endDate=new Date()] - Campaign end date.
	 * @param {ChannelDataObject[]} channels - Campaign channels.
	 */
	constructor(
		type = CAMPAIGN_TYPE.REGULAR, projectId = '', name = '', description = '', startDate = new Date(), 
		endDate = addDays(new Date(), 1), channels = [] 
	) {
		this.type = type;
		this.projectId = projectId;
		this.name = name;
		this.description = description;
		this.startDate = startDate;
		this.endDate = endDate;
		this.channels = channels;
	}
}